import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
  value: string | number;
  isBold?: boolean;
};

export const RewardsSummaryItem = ({ title, value, isBold = false }: Props) => (
  <Box display="flex" gap={10} justifyContent="space-between">
    <Typography>{title}</Typography>
    <Typography fontWeight={isBold ? "bold" : "normal"}>{value}</Typography>
  </Box>
);
